export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20gradient%20background%20with%20warm%20coral%20red%20and%20orange%20tones%20blending%20smoothly%2C%20soft%20geometric%20shapes%20floating%2C%20modern%20digital%20media%20aesthetic%2C%20dynamic%20energy%20flow%2C%20clean%20minimal%20design%20with%20depth&width=1800&height=900&seq=hero-bg-douyinpro&orientation=landscape"
          alt="抖阴pro - 短视频内容平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
            <span className="text-sm text-background-50/90">2026年8月最新版本已发布</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-4">
            发现世界的
            <span className="text-accent-400">精彩</span>
            瞬间
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            抖阴pro —— 海量优质短视频内容平台，智能推荐、超清画质、丰富互动，让每一次刷视频都充满惊喜与乐趣
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-4 rounded-xl bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line mr-2"></i>
              立即下载抖阴pro
            </a>
            <a
              href="#features"
              className="w-full sm:w-auto px-8 py-4 rounded-xl bg-background-50/15 backdrop-blur-sm text-background-50 text-base font-medium border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </a>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">5.8亿+</div>
              <div className="text-sm text-background-50/60 mt-1">累计用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">4.8</div>
              <div className="text-sm text-background-50/60 mt-1">用户评分</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">1200万+</div>
              <div className="text-sm text-background-50/60 mt-1">创作者</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}